import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
    actions: {
        async getContainersData(context) {
            const response = await Vue.axios.get(`${URL_API}containertype`);
            let data = response["data"];
            context.commit("updateContainersData", data);
        },
        async createContainerData(context, name) {
            const config = {};
            const body = {
                name: name
            };
            await Vue.axios.post(`${URL_API}containertype/store`, body, config);
            context.dispatch("getContainersData");
        },
        async pushContainerData(context, { id, name }) {
            const config = {};
            const body = {
                id: id,
                name: name
            };
            await Vue.axios.post(`${URL_API}containertype/update`, body, config);
            context.dispatch("getContainersData");
        },
        async destroyContainerData(context, id) {
            const config = {};
            const body = {
                id: id
            };
            await Vue.axios.post(`${URL_API}containertype/destroy`, body, config);
            context.dispatch("getContainersData");
        }
    },
    mutations: {
        updateContainersData(state, containersData) {
            state.containersData = containersData;
        }
    },
    state: {
        containersData: []
    },
    getters: {
        allContainersData(state) {
            return state.containersData;
        }
    }
};